import React, { createContext, useContext, useState, useCallback } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { LeadForm } from "@/components/site/LeadForm";
import { PublicVisitForm } from "@/components/site/PublicVisitForm";

const BookingContext = createContext(null);

export function BookingProvider({ children }) {
  const [state, setState] = useState({ open: false, type: "site_visit", project: "", slug: "", unitId: "", projectId: "" });

  const open = useCallback((type = "site_visit", project = "", slug = "", unitId = "", projectId = "") => {
    setState({ open: true, type, project, slug, unitId, projectId });
  }, []);
  const setOpen = (v) => setState((s) => ({ ...s, open: v }));

  const title = state.type === "site_visit" ? "Book a Site Visit" : state.type === "brochure" ? "Download Brochure" : "Make an Enquiry";
  const sub = state.type === "site_visit"
    ? "Experience the residence in person. Our team will confirm your slot."
    : state.type === "brochure"
    ? "Enter your details and your brochure will download instantly."
    : "Tell us what you're looking for and we'll be in touch shortly.";

  return (
    <BookingContext.Provider value={{ open, isOpen: state.open }}>
      {children}
      <Dialog open={state.open} onOpenChange={setOpen}>
        <DialogContent
          className="z-[10001] max-h-[calc(100dvh-1rem)] w-[calc(100vw-1rem)] max-w-md overflow-hidden border-white/10 bg-ink-2 p-0 text-white sm:max-h-[86vh] [&>button]:z-20 [&>button]:flex [&>button]:h-9 [&>button]:w-9 [&>button]:items-center [&>button]:justify-center [&>button]:rounded-full [&>button]:bg-ink/95 [&>button]:text-white [&>button]:opacity-100"
          data-testid="booking-modal"
        >
          <div className="max-h-[calc(100dvh-1rem)] overflow-y-auto overscroll-contain p-4 pr-12 sm:max-h-[86vh] sm:p-5 sm:pr-12">
            <DialogHeader className="space-y-1">
              <div className="overline mb-1">Aureon Estates</div>
              <DialogTitle className="font-serif text-2xl font-light tracking-tight text-white sm:text-3xl">{title}</DialogTitle>
              <DialogDescription className="text-sm leading-relaxed text-white/50">{sub}</DialogDescription>
            </DialogHeader>
            <div className="pt-3">
              {state.type === "site_visit" ? <PublicVisitForm defaultProject={state.project} defaultProjectId={state.projectId} defaultUnitId={state.unitId} onSuccess={() => setOpen(false)} /> : <LeadForm compact leadType={state.type} defaultProject={state.project} defaultProjectId={state.projectId} defaultUnitId={state.unitId} brochureSlug={state.slug} onSuccess={() => setOpen(false)} />}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </BookingContext.Provider>
  );
}

export const useBooking = () => useContext(BookingContext);
